function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIconTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13285",
    transform: "translate(-855 -771)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 694",
    width: 32,
    height: 32,
    rx: 16,
    transform: "translate(855 771)",
    style: {
      fill: "#015fe5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 6",
    transform: "translate(871 781.667)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    d: "M0 0v10.667"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 7",
    transform: "translate(865.667 787)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    d: "M0 0h10.667"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconTable);
export default __webpack_public_path__ + "static/media/PlusIconTable.9246651f77ab727580795bbcc2d57558.svg";
export { ForwardRef as ReactComponent };